/**
 * Hard-coded route → roles that must always keep access even if
 * role_menu_access / client menu cache is missing or stale.
 * Keep in sync with App.js staffCanOpen legacy lists for these paths.
 */
const EXACT = {
  "/cafe-dashboard": ["1", "3", "4", "7"],
  "/cafe-category": ["1", "3", "4", "7"],
  "/cafe-cart": ["1", "3", "4", "7"],
  "/cafe_checkout": ["1", "3", "4", "7"],
  "/cafe": ["1", "3", "4", "7"],
  "/cafe-deposit": ["1", "3", "4", "7"],
  "/deposit-client-balance": ["1", "3", "4", "7"],
  "/clients-available-balance": ["1", "3", "4", "7"],
  "/deposit-history": ["1", "3", "4", "7"],
  "/cafe-sales": ["1", "3", "4", "7"],
  "/cafe-sales-report": ["1", "3", "4", "7"],
  "/detailed-cafe-report": ["1", "3", "4", "7"],
  "/management-pendings": ["1", "3", "4", "7"],
  "/hr-dashboard": ["1", "3", "4", "12"],
  "/session-tracker": ["1", "3", "9", "11"],
  "/pt-dashboard": ["1", "3", "9", "11"],
  "/trainer-slots": ["1", "3", "4", "9", "11"],
  "/gt-dashboard": ["1", "3", "11", "17"],
  "/fitness-manager-dashboard": ["1", "3", "11"],
  "/personal-trainer": ["1", "3", "4", "9", "11"],
  "/nutrition/dashboard": ["1", "3", "10", "11"],
  "/social-media-dashboard": ["1", "3", "16"],
  "/admin-dashboard": ["1"],
  "/admin-reminders": ["1"],
  "/cafe-overview": ["1", "3"],
  "/mis-report": ["1"],
  "/dashboard": ["1", "3", "4"],
  "/employee-dashboard": ["1", "3", "4", "5", "7", "9", "10", "11", "12", "13", "15", "16", "17"],
};

const PREFIX = [
  { prefix: "/cafe-invoice/", roles: ["1", "3", "4", "7"] },
  { prefix: "/cafe-slip/", roles: ["1", "3", "4", "7"] },
  { prefix: "/cafe_check_out/", roles: ["1", "3", "4", "7"] },
];

/** True when this role is allowed on pathname via hard-coded cafe/sales routes. */
export function legacyAllowsPath(role, pathname) {
  const r = String(role ?? "");
  const p = String(pathname ?? "");
  if (!r || !p) return false;

  const exactRoles = EXACT[p];
  if (exactRoles && exactRoles.includes(r)) return true;

  for (const row of PREFIX) {
    if (p.startsWith(row.prefix) && row.roles.includes(r)) return true;
  }
  return false;
}
